<template>
  <section
    role="dialog"
    :aria-labelledby="'modal-title-' + _uid"
    class="fixed flex flex-col font-body h-screen inset-0 items-center justify-center w-full z-50"
  >
    <div
      class="absolute flex h-screen items-center justify-center w-full"
      style="background-color: rgba(0, 0, 0, 0.5)"
    >
      <div
        :class="'bg-white rounded shadow p-4 m-4 max-h-full overflow-y-auto max-w-xl ' + boxClass"
        style="min-width: 30%;"
      >
        <h2
          :id="'modal-title-' + _uid"
          class="px-6 py-8 text-2xl"
        >
          <slot name="title" />
        </h2>
        <slot />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LayoutModal',

  props: {
    boxClass: {
      type: String,
      default: () => ''
    }
  }
};
</script>
